import React from 'react';
import { PageLayout } from '../PageLayout';

const usp = (uspText) => ({
  type: 'Div',
  props: {
    display: 'flex',
    alignItems: 'center',
    gridGap: 1,
  },
  _children: [
    {
      type: 'IconV2',
      props: {
        name: 'green-check',
        size: 28,
      },
    },
    {
      type: 'P',
      props: {
        fontWeight: 300,
        variant: 'footnoteRegularLight',
        color: '#9B9B9B',
        children: uspText,
      },
    },
  ],
});

function getUsps(isOs, pageName) {
  if (isOs) {
    switch (pageName) {
      case 'os-solar-panels':
        return [
          usp('Grootste aanbod aan leveranciers'),
          usp('Profiteer van exclusieve kortingen'),
          usp('Altijd de beste deal'),
        ];
      case 'os-savings':
        return [
          usp('Groot aanbod aan producten'),
          usp('100% onafhankelijk'),
          usp('Profiteer van hoge rentes'),
        ];
      case 'os-triple-play':
        return [
          usp(`Grootste aanbod aan providers`),
          usp('Profiteer van exclusieve kortingen'),
          usp('Altijd de beste deal'),
        ];
      case 'moneysure-event-based':
      case 'os-business-car':
        return [
          usp('Snel duidelijkheid'),
          usp('Speciaal voor ondernemers'),
          usp('Direct online af te sluiten'),
        ];
      case 'os-home':
      case 'os-travel':
      case 'os-health':
        return [
          usp('Grootste aanbod aan verzekeraar'),
          usp('Profiteer van exclusieve kortingen'),
          usp('Altijd de beste deal'),
        ];
      default:
        console.error('No USPs were set for this comparator');
        return [];
    }
  } else {
    return [
      usp('Onafhankelijk en betrouwbaar advies'),
      usp('Wij regelen je overstap'),
      usp('Consumenten geven ons een 8,4'),
    ];
  }
}

export const OverviewPageLoader = ({
  isOs = false,
  pageName = '',
  customContent,
  isPartner,
}: {
  isOs?: boolean;
  pageName?: string;
  customContent?: {
    content?: any;
    contentStyles?: any;
  };
  isPartner?: boolean;
}) => {
  const usps = getUsps(isOs, pageName);

  const showCustomContent = customContent?.content && isPartner === false;

  return (
    <PageLayout
      textAlign="center"
      bg="second.2"
      divHeight="0"
      contentStyles={{
        gridColumn: 'span 12 !important',
        justifyContent: 'center',
        ...customContent?.contentStyles,
      }}
      content={
        showCustomContent
          ? customContent?.content
          : [
              {
                type: 'Div',
                props: {
                  maxWidth: '327px',
                  minHeight: '100vh',
                  margin: ['auto', 'auto', 'auto'],
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                _children: [
                  {
                    type: 'Div',
                    props: {
                      bg: 'background',
                      borderRadius: 2,
                      boxShadow: 'default',
                      p: 4,
                      display: 'flex',
                      flexDirection: 'column',
                      gridGap: 6,
                      alignItems: 'center',
                    },
                    _children: [
                      {
                        type: 'Div',
                        _children: [
                          {
                            type: 'Spinner',
                            props: {
                              margin: 1,
                              width: '22px',
                              height: '22px',
                              color: '#D8D8D8',
                            },
                          },
                          {
                            type: 'Heading',
                            props: {
                              as: 'h3',
                              variant: 'H3',
                              color: '#05164C',
                              m: 0,
                              children: 'Een momentje...',
                            },
                          },
                          {
                            type: 'P',
                            props: {
                              fontWeight: 300,
                              variant: 'bodyRegular',
                              color: '#05164C',
                              children:
                                'Wij zoeken nu de beste deals die bij jouw wensen passen.',
                            },
                          },
                        ],
                      },
                      {
                        type: 'Div',
                        _children: usps,
                      },
                    ],
                  },
                ],
              },
            ]
      }
    />
  );
};
